export const Data = {
  nav: ["Projects", "Technologies", "About"],
  projects: [
    {
      name: "COMPANY WEBSITE",
      img: "./img/port2.png",
      des: ` Using react, material ui and bootstrap i built a user appealing design
      and attractive admin panel
      `,
      stack: ["Next.js,", "MYSQL,", "Jquery,", "Bootstrap,", "PHP"],
      code: `https://github.com/DOGGED-DESIGNS/sanagossafety`,
      visit: `https://sanagossafety.com`,
    },
    {
      name: "GOIF ORGANIZATION",
      img: "./img/port1.png",
      code: `https://github.com/DOGGED-DESIGNS/management`,
      visit: `https://www.goif.org.ng/`,

      stack: ["PHP,", "Mysql,", "talewindcss,", "Sass,", "jquery,"],
      des: `
            Design an development of a well functioning and attractive  website for
            Goif foundation 
            `,
    },
    {
      name: "RELATIONSHIP BLOG",
      img: "./img/port3.png",
      code: `https://github.com/DOGGED-DESIGNS/womenlove`,
      visit: `https://womenlove.vercel.app/`,

      stack: ["Next.js", "Node.js", "Api", "mongodb", "jquery"],
      des: `
           Realtor website with beautiful attactive design
           created using React.js, Rapid Api, and Material Ui
            `,
    },
    {
      name: "SAFETY BLOG",
      img: "./img/port4.png",
      code: `https://github.com/DOGGED-DESIGNS/sanagossafety`,
      visit: `https://sanagossafety.com/blog`,

      stack: ["Next.js,", "PHP,", "MYSQL,", "API,", "SASS,", "jquery"],
      des: `
           Realtor website with beautiful attactive design
           created using React.js, Rapid Api, and Material Ui
            `,
    },
  ],
};
